import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _this = this;
var __jsx = React.createElement;
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import classNames from "classnames";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
var DebounceInput = function DebounceInput(props) {
  var value = props.value,
    onChange = props.onChange,
    placeholder = props.placeholder,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    _props$inputClassName = props.inputClassName,
    inputClassName = _props$inputClassName === void 0 ? "" : _props$inputClassName,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    LHSIcon = props.LHSIcon,
    RHSIcon = props.RHSIcon,
    hasClear = props.hasClear,
    closeIcon = props.closeIcon;
  var _useState = useState(""),
    text = _useState[0],
    setText = _useState[1];
  useEffect(function () {
    if (value != text) {
      setText(value);
    }
  }, [value]);
  var debounce = function debounce(func) {
    var timer;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var context = _this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };
  var handleChange = function handleChange(val) {
    setText(val);
    optimizedFn(val);
  };
  var optimizedFn = useCallback(debounce(function (val) {
    onChange ? onChange(val) : null;
  }), []);
  return /*#__PURE__*/React.createElement("label", {
    className: classNames("relative text-gray-500 dark:text-gray-400 block w-full", _defineProperty({}, className, !!className))
  }, LHSIcon, /*#__PURE__*/React.createElement("input", {
    value: text,
    className: classNames("form-input w-full p-3 pl-8 pr-8 bg-gray-200 dark:bg-gray-800 rounded-md border-transparent focus:border-transparent text-md", _defineProperty(_defineProperty({
      " !border-teal-300": !_.isEmpty(text)
    }, inputClassName, !!inputClassName), "!border-teal-500 dark:!border-teal-300", !_.isEmpty(text) && !!inputClassName)),
    placeholder: placeholder,
    title: placeholder,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    disabled: disabled
  }), hasClear && !!text && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center h-full w-6 absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer !text-gray-400 dark:text-gray-600",
    onClick: function onClick(e) {
      handleChange("");
      e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "lg",
    className: classNames("")
  })), closeIcon, RHSIcon);
};
export default DebounceInput;